import React, { useContext, useEffect, useState } from "react";
import { Alert, Dialog, Table } from "../../../layout";
import { Button } from "../../../controls";
import { IconButton, Tooltip } from "@mui/material";
import { ClearRounded, EditRounded } from "@mui/icons-material";
import AddEditTax from "./AddEditTax";
import { AppContext } from "../../../App";
import { API, action, controller } from "../../../api/api";
import { formatDate } from "hooks";

const Taxes = () => {
  const [updData, setUpdData] = useState();
  const [showForm, setShowForm] = useState(false);
  const { authUser, setLoader, access } = useContext(AppContext);
  const [taxes, setTaxes] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    setLoader(true);
    if (authUser.id) {
      API(controller.Tax + action.GetAllByOrg).get((res) => {
        res.status === 200 && setTaxes([...res.result]);
        setLoader(false);
      });
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  const handleAddEdit = (data) => {
    setUpdData(data);
    setShowForm(true);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: "Are you sure",
      subTitle: "You want to delete this tax?",
      onConfirm: () => {
        const onComplete = (res) => {
          if (res && res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: "Deleted Successfully",
              subTitle: res.msg,
            });
            setTaxes((x) => [...x.filter((j) => j.id !== res.result.id)]);
          } else {
            setAlert({
              isOpen: true,
              type: "warning",
              title: "Warning",
              subTitle: res.msg,
            });
          }
        };
        API(controller.Tax).Delete(id, onComplete);
      },
    });
  };

  const ActionComp = (val) => (
    <div className="bs-secondary br-8 w-fit">
      {access?.taxRate?.create && (
        <Tooltip title="Edit">
          <IconButton
            onClick={() => handleAddEdit(val)}
            size="small"
            color="primary"
            className="mr-5 p-5"
          >
            <EditRounded className="fs-18 m-2" />
          </IconButton>
        </Tooltip>
      )}
      {access?.taxRate?.delete && (
        <Tooltip title="Delete">
          <IconButton
            onClick={() => handleDlt(val.id)}
            size="small"
            color="error"
            className="mr-5 p-5"
          >
            <ClearRounded className="fs-18 m-2" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );

  const HeaderComp = () =>
    access?.taxRate?.create && (
      <Button onClick={() => handleAddEdit()}>Add Tax</Button>
    );

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "name", label: "Name" },
          { id: "rate", label: "Rate (%)" },
          { id: "createDate", label: "Create Date" },
          { id: "actions", label: "Actions" },
        ]}
        tblData={[
          ...taxes.map((j) => ({
            ...j,
            createDate: formatDate(j.createDate),
          })),
        ]}
      />

      {/* Add Follow Up */}
      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="sm">
          <AddEditTax
            {...{ setShowForm: setShowForm, updData, setAlert, setTaxes }}
          />
        </Dialog>
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Taxes;
